import { render, staticRenderFns } from "./LargeAvatar.vue?vue&type=template&id=53a9e603&scoped=true&"
import script from "./LargeAvatar.vue?vue&type=script&lang=ts&"
export * from "./LargeAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./LargeAvatar.vue?vue&type=style&index=0&id=53a9e603&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a9e603",
  null
  
)

export default component.exports